$(function () {
  const $body = $('body');
  const $form = $('#form');

  if (!$form.length) return;

  const $nameElement = $form.find('#name');
  const $rubyElement = $form.find('#ruby');
  const $emailElement = $form.find('#email');
  const $telElement = $form.find('#tel');
  // const $resumeElement = $form.find('#resume');
  // const $careerElement = $form.find('#career');
  const $detailElement = $form.find('#detail');
  const $agreementElement = $form.find('#agreement');

  // const $resumeInputButton = $form.find('.js-resumeInputButton');
  // const $careerInputButton = $form.find('.js-careerInputButton');

  const $confirmButton = $form.find('.js-confirmButton');

  let nameValue;
  let rubyValue;
  let emailValue;
  let telValue;
  // let resumeValue;
  // let careerValue;
  let detailValue;

  // const $resumeFilePath = $form.find('.js-resumeFilePath');
  // const $careerFilePath = $form.find('.js-careerFilePath');

  const $textareaCounterElement = $form.find('.js-textareaCounter');

  const $nameErrorElement = $form.find('.js-nameError');
  const $rubyErrorElement = $form.find('.js-rubyError');
  const $emailErrorElement = $form.find('.js-emailError');
  const $telErrorElement = $form.find('.js-telError');
  // const $resumeErrorElement = $form.find('.js-resumeError');
  // const $careerErrorElement = $form.find('.js-careerError');
  const $detailErrorElement = $form.find('.js-detailError');
  const $agreementErrorElement = $form.find('.js-agreementError');
  const errorElements = [
    $nameErrorElement,
    $rubyErrorElement,
    $emailErrorElement,
    $telErrorElement,
    // $resumeErrorElement,
    // $careerErrorElement,
    $detailErrorElement,
    $agreementErrorElement,
  ];

  const $confirmationModal = $('.js-confirmationModal');
  const $modalOverlay = document.querySelector('.js-modalOverlay');

  const $nameConfirm = $confirmationModal.find('.js-nameConfirm');
  const $rubyConfirm = $confirmationModal.find('.js-rubyConfirm');
  const $emailConfirm = $confirmationModal.find('.js-emailConfirm');
  const $telConfirm = $confirmationModal.find('.js-telConfirm');
  // const $resumeConfirm = $confirmationModal.find('.js-resumeConfirm');
  // const $careerConfirm = $confirmationModal.find('.js-careerConfirm');
  const $detailConfirm = $confirmationModal.find('.js-detailConfirm');

  const $submitButton = $confirmationModal.find('.js-submitButton');
  const $sendingLoadingCircle = $confirmationModal.find('.js-sendingLoadingCircle');

  const $completeModal = $('.js-completeModal');

  let isValid = false;

  const htmlEscape = (str) => {
    if (!str) return;
    return str.replace(/[<>&"'`]/g, (match) => {
      const escape = {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#x60;',
      };
      return escape[match];
    });
  };

  const countTextarea = () => {
    const count = $detailElement.val().length;
    $textareaCounterElement.text(count);
  };

  function validateForm() {
    nameValue = htmlEscape($nameElement.val());
    rubyValue = htmlEscape($rubyElement.val());
    emailValue = htmlEscape($emailElement.val());
    telValue = htmlEscape($telElement.val());
    // resumeValue = $resumeElement.val();
    // careerValue = $careerElement.val();
    detailValue = htmlEscape($detailElement.val());

    resetErrorElements();

    isValid = true;

    if (!nameValue) {
      $nameErrorElement.text('お名前を入力してください。');
      $nameErrorElement.css('display', 'block');
      isValid = false;
    }

    if (!rubyValue) {
      $rubyErrorElement.text('ふりがなを入力してください。');
      $rubyErrorElement.css('display', 'block');
      isValid = false;
    }

    if (!/\S+@\S+\.\S+/.test(emailValue)) {
      $emailErrorElement.text('メールアドレスを正しく入力してください。');
      $emailErrorElement.css('display', 'block');
      isValid = false;
    }

    if (!telValue) {
      $telErrorElement.text('電話番号を入力してください。');
      $telErrorElement.css('display', 'block');
      isValid = false;
    } else if (!/^0[-\d]{9,12}$/.test(telValue)) {
      $telErrorElement.text('電話番号は半角数字で入力してください。');
      $telErrorElement.css('display', 'block');
      isValid = false;
    }

    // if (!resumeValue) {
    //   $resumeErrorElement.text('履歴書を選択してください。');
    //   $resumeErrorElement.css('display', 'block');
    //   isValid = false;
    // } else {
    //   const resumeFile = $resumeElement.prop('files')[0];
    //   if (!/\.(pdf|doc|docx)$/i.test(resumeFile.name)) {
    //     $resumeErrorElement.text('履歴書には、PDFまたはWordファイルを選択してください。');
    //     isValid = false;
    //   }
    // }

    // if (!careerValue) {
    //   $careerErrorElement.text('職務経歴書を選択してください。');
    //   $careerErrorElement.css('display', 'block');
    //   isValid = false;
    // } else {
    //   const careerFile = $careerElement.prop('files')[0];
    //   if (!/\.(pdf|doc|docx)$/i.test(careerFile.name)) {
    //     $careerErrorElement.text('職務経歴書はPDFまたはWordファイルを選択してください。');
    //     isValid = false;
    //   }
    // }

    if (detailValue && detailValue.length > 500) {
      $detailErrorElement.text('備考は500文字以内で入力してください。');
      $detailErrorElement.css('display', 'block');
      isValid = false;
    }

    if (!$agreementElement.prop('checked')) {
      $agreementErrorElement.text('個人情報の取り扱いポリシーに同意してください。');
      $agreementErrorElement.css('display', 'block');
      isValid = false;
    }
  }

  function confirmForm() {
    detailValue = !detailValue ? '（なし）' : detailValue;

    $nameConfirm.html(nameValue);
    $rubyConfirm.html(rubyValue);
    $emailConfirm.html(emailValue);
    $telConfirm.html(telValue);
    // resumeとcareerはファイル名のみ表示
    // $resumeConfirm.html(resumeValue.replace(/^.*[\\\/]/, ''));
    // $careerConfirm.html(careerValue.replace(/^.*[\\\/]/, ''));
    $detailConfirm.html(detailValue);

    $confirmationModal.addClass('is-show');
    $modalOverlay.classList.add('is-show');
    $body.addClass('is-fixed');
  }

  const resetForm = () => {
    $nameElement.val('');
    $rubyElement.val('');
    $emailElement.val('');
    $telElement.val('');
    // $resumeElement.val('');
    // $careerElement.val('');
    $detailElement.val('');
    $agreementElement.prop('checked', false);
    // $careerFilePath.text('ファイルを選択してください');
    // $resumeFilePath.text('ファイルを選択してください');
  };

  function submitForm() {
    const formData = new FormData();

    formData.append('name', nameValue);
    formData.append('ruby', rubyValue);
    formData.append('email', emailValue);
    formData.append('tel', telValue);
    // formData.append('resume', $resumeElement.prop('files')[0]);
    // formData.append('career', $careerElement.prop('files')[0]);

    formData.append('detail', detailValue);

    formData.append('action', 'send_mail'); // サーバーのアクション名

    $submitButton.prop('disabled', true);
    $submitButton.addClass('is-disabled');
    $sendingLoadingCircle.removeClass('is-hidden');

    fetch(ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.text())
      .then(() => {
        $confirmationModal.removeClass('is-show');
        $completeModal.addClass('is-show');

        $submitButton.prop('disabled', false);
        $submitButton.removeClass('is-disabled');
        $sendingLoadingCircle.addClass('is-hidden');

        resetForm();
      })
      .catch((error) => {
        console.error('Error: ' + error);
        alert(
          '大変申し訳ございませんが、正常に送信されませんでした。恐れ入りますが、ネットワーク環境をご確認いただくか、しばらく時間をおいてお問い合わせいただきますよう、お願いいたします。',
        );

        $submitButton.prop('disabled', false);
        $submitButton.removeClass('is-disabled');
        $sendingLoadingCircle.addClass('is-hidden');
      });
  }

  const setEvents = () => {
    // $careerInputButton.on('click', function (e) {
    //   e.preventDefault();
    //   $careerElement.click();
    // });

    // $resumeInputButton.on('click', function (e) {
    //   e.preventDefault();
    //   $resumeElement.click();
    // });

    // $careerElement.on('change', function () {
    //   const careerFile = $careerElement.prop('files')[0];
    //   $careerFilePath.text(careerFile.name);
    // });

    // $resumeElement.on('change', function () {
    //   const resumeFile = $resumeElement.prop('files')[0];
    //   $resumeFilePath.text(resumeFile.name);
    // });

    $detailElement.on('keyup', function () {
      countTextarea();
    });

    $confirmButton.on('click', function (e) {
      e.preventDefault();
      validateForm();

      if (!isValid) {
        const entrySection = document.getElementById('entry');
        const entrySectionTop = entrySection.getBoundingClientRect().top;
        const entrySectionOffsetTop = window.scrollY + entrySectionTop;
        window.scrollTo({
          top: entrySectionOffsetTop,
          behavior: 'smooth',
        });

        return false;
      } else {
        confirmForm();
        return false;
      }
    });

    $submitButton.on('click', function () {
      if (!isValid) {
        return false;
      } else {
        submitForm();
      }
    });
  };

  const resetErrorElements = () => {
    errorElements.forEach(function (errorElement) {
      errorElement.empty();
      errorElement.css('display', 'none');
    });
  };

  const init = () => {
    setEvents();
    resetForm();
    resetErrorElements();
    countTextarea();
  };

  init();
});
